import { useState, KeyboardEvent, ChangeEvent, useRef } from 'react';
import styled from 'styled-components';
import { Button } from '@salecycle/ui-component-library';
import { useTranslation } from 'react-i18next';

const InputContainer = styled.div`
  display: flex;
  gap: 8px;
  padding: 12px;
  border-top: 1px solid #e0e0e0;
  background-color: #ffffff;
`;

const InputArea = styled.textarea`
  flex: 1;
  padding: 10px 16px;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  font-size: 14px;
  min-height: 40px;
  max-height: 20vh;
  resize: none;
  overflow: auto;
  outline: none;
  &:focus {
    border-color: #007bff;
  }
  &::placeholder {
    color: #999;
  }
`;

interface ChatInputProps {
  onSend: (message: string) => void;
  disabled?: boolean;
  placeholder?: string;
}

export function ChatInput({ onSend, disabled = false, placeholder = 'Type your question...' }: ChatInputProps) {
  const { t } = useTranslation('agents');
  const [input, setInput] = useState('');
  const inputRef = useRef<HTMLTextAreaElement>(null);

  const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    if (inputRef.current) {
      inputRef.current.style.height = 'auto';
      inputRef.current.style.height = `${inputRef.current.scrollHeight}px`;
    }
    setInput(e.target.value);
  };

  const handleSend = () => {
    if (input.trim() && !disabled) {
      onSend(input.trim());
      setInput('');
      if (inputRef.current) {
        inputRef.current.style.height = 'auto';
      }
    }
  };

  const handleKeyPress = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <InputContainer>
      <InputArea
        ref={inputRef}
        value={input}
        onChange={handleChange}
        onKeyPress={handleKeyPress}
        placeholder={t('campaignAssistant.chatMessage.userMessagePlaceholder')}
        disabled={disabled}
      />
      <Button onClick={handleSend} disabled={disabled || !input.trim()}>
        {t('campaignAssistant.chatMessage.sendButtonLabel')}
      </Button>
    </InputContainer>
  );
}
